var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gmap-cont"},[_c('div',{staticClass:"input-group"},[_c('gmap-autocomplete',{on:{"place_changed":_vm.setPlace}})],1),_vm._v(" "),_c('gmap-map',{ref:"mapRef",staticStyle:{"width":"100%","height":"15rem"},attrs:{"center":_vm.center,"zoom":8}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }